import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from 'react'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import { AddNewDepartmentIcon, CalenderIcon, CloseIcon, DepartmentIcon, DocumentIcon, DownIcon, EditDepartmentIcon, FormIconDataPicker, IdIcon, MobileIcon, NewWarningIcon, PrimaryCourseIcon, SearchIcon, UpIcon } from '../iconSet/IconSet'
import { SelectItemTypes } from '../../CommonTypes'
import InputGroup from '../inputComp/InputGroup'
import { AdministrativeLevel, AdministrativeLevels, EarlyWarning, EarlyWarningTypeTypes, FlatAdmin, GUSAdminData, GUSDataRefType, HWNAdminData, HWNDataRefType, ResponseGetActiveWarningDto } from './CreateWarningTypes'
import { getAdminLevelByCode, maldivesAdministrativeLevel, maldivesSeaAdministrativeLevel, sriLankaAdministrationLevel } from './FixedDataSet'
import { convertToOffsetDateTime, flatMap, paginationList, parseCSVManually, sideFieldCount, SubscriberDataType, validateCSVFormat } from './CommonMethods'
import useInputValidate from '../../hooks/useInputValidate'
import MapSelector from './MapSelector'
import { AdminData } from './MapSelectorPopup'
import { APICallGenerateEWMsgRequest, APICallGenerateProcKeyRequest, APICallNewHWNRequest, APICallNewWarningRequest, APIRequestAddAreaTypes, APIRequestAddHWNAreaTypes, APIRequestAddHWNTypes, APIRequestSelectedSubscribersType, APIRequestWarningAddTypes, APIResponseSelectedSubscribersType, APISaveGroupSubTypes, APIWarningTypeResponseType, ResponseTypes } from '../../services/APIEarlyWarningService'
import AlertDialog from '../popupComp/AlertDialog'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import { Department } from '../OrganizationAddUserComp/OrganizationAddUserTypes'
import { useUserData } from '../../context/UserDataContext'
import { APIGetUserAreas } from './CreateWarningService'

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from '../../context/ThemeContext'
import { APIGetAllCustomSubscribers, Subscriber } from './EarlyWarningService'
import { GetSelectedGroup } from '../warningWorkflowProcessComp/WarningWorkflowProcess'
import { UserDataRow } from '../earlyWarning/emailComp/EmailTypes'
import GroupSelectTable from '../warningWorkflowProcessComp/GroupSelectTable'
import UserSelectTable from '../warningWorkflowProcessComp/UserSelectTable'

type GUSWarningPropsType = {
    ewType: APIWarningTypeResponseType;
    username: string;
 }

 interface RowState {
    isSelected: boolean;
    minWind: number;
    maxWind: number;
    severity: string;
    lightingRiskLevel: string;
    startDate: string;
    endDate: string;
}

const GUSWarning = (props: GUSWarningPropsType) => {

    const { theme } = useTheme()

    const { username, areas } = useUserData()

    const BASE_URL = process.env.REACT_APP_BASE_URL
    const COUNTRY = process.env.REACT_APP_COUNTRY
    
    const { department, contact } = useUserData()

    const [departments, setDepartments] = useState<SelectItemTypes[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false)
    // Custom hook
    const {validateField} = useInputValidate()

    const [hiddenIslandCodes, setHiddenIslandCodes] = useState<string[]>([])

    // Primary cause
    const [gusPrimaryCause, setGUSPrimaryCause] = useState<SelectItemTypes[]>([
        {name: "Southwest monsoon", value: "southwest_monsoon"},
        {name: "Northeast monsoon", value: "northeast_monsoon"},
        {name: "Low level atmospheric disturbance", value: "low_level_atmospheric_disturbance"},
    ])

    // Previous alert level
    const [gusSeverity, setGUSSeverity] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    // New alert level
    const [gusLightning, setGUSLightning] = useState<SelectItemTypes[]>([
        { name: "Low", value: "low" },
        { name: "Moderate", value: "moderate" },
        { name: "High", value: "high" },
    ])

    // Number of rows in table
    const [numberOfRows, setNumberOfRows] = useState<number>(10)
    const numberOfRowsRef = useRef<HTMLInputElement | null>(null)

    // Supportive document
    const [fileName, setFileName] = useState<string>('Upload');
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };

    const [rowStates, setRowStates] = useState<Record<string, RowState>>({});

    const gusNumberRef = useRef<HTMLInputElement | null>(null)
    const gusRequestNameRef = useRef<HTMLInputElement | null>(null)
    const gusContactNumberRef = useRef<HTMLInputElement | null>(null)
    const gusPreRequestDocumentRef = useRef<HTMLInputElement | null>(null)
    const gusValidityStartRef = useRef<HTMLInputElement | null>(null)
    const gusValidityEndRef = useRef<HTMLInputElement | null>(null)
    const gusDateRef = useRef<HTMLInputElement | null>(null)
    const gusRequestersDepartmentRef = useRef<HTMLSelectElement | null>(null)
    // HWN
    const gusPrimaryCauseRef = useRef<HTMLSelectElement | null>(null)

    const gusTextAreaEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const gusReportedLinkRef = useRef<HTMLInputElement | null>(null)

    const gusTextAreaCusEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaCusDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaCusSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaCusBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const gusTextAreaCusTamilRef = useRef<HTMLTextAreaElement | null>(null)

    const [messagingAreaStatus, setMessageAreaStatus] = useState<boolean>(false)

    const [csvErrors, setCSVErrors] = useState<string | null>(null)
    const [fileCSVName, setFileCSVName] = useState<string>('Upload');
    const fileInputCSVRef = useRef<HTMLInputElement>(null)
    const [csvData, setCSVData] = useState<SubscriberDataType[]>([])

    const csvSubNameRef = useRef<HTMLInputElement | null>(null)

    const subscriberSaveRef = useRef<HTMLInputElement | null>(null)

    const [isCSVDataPikerOpen, setIsCSVDataPikerOpen] = useState<boolean>(false)
    const [isCSVDataPickerLoading, setIsCSVDataPickerLoading] = useState<boolean>(false)

    // Area selection status
    const [areaSelectType, setAreaSelectType] = useState<'table' | 'map'>('table')

    const [startDate, setStartDate] = useState<string>('')
    const handleStartDateChange = () => {
        if(gusValidityStartRef.current) {
            console.log("data start" ,gusValidityStartRef.current.value)
            setStartDate(gusValidityStartRef.current.value)
        }
    }

    const [endDate, setEndDate] = useState<string>('')
    const handleEndDateChange = () => {
        if(gusValidityEndRef.current) {
            console.log("data end" ,gusValidityEndRef.current)
            setEndDate(gusValidityEndRef.current.value)
        }
    }

    useEffect(() => {
        if (startDate) {
            setGUSTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "GUS") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                startDate: startDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [startDate]);

    useEffect(() => {
        if (endDate) {
            setGUSTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "GUS") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                endDate: endDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [endDate]);

    const dataMap: InputGroupPropsTypes[] = [
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter GUS Number',
            label: 'GUS Number',
            name: 'GUSNumber',
            required: true,
            componentInputElement: gusNumberRef,
            disabled: true
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Request Name',
            label: 'Request Name',
            name: 'RequestName',
            required: false,
            componentInputElement: gusRequestNameRef,
            disabled: true
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter start valid period',
            label: 'validity start time',
            name: 'validityStartTime',
            required: true,
            componentInputElement: gusValidityStartRef,
            onChange: handleStartDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'validity end time',
            name: 'validityEndTime',
            required: true,
            componentInputElement: gusValidityEndRef,
            onChange: handleEndDateChange
        },
        {
            type: 'text',
            icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Contact number',
            label: 'contact number',
            name: 'contactNumber',
            required: false,
            componentInputElement: gusContactNumberRef,
        },
        {
            type: 'text',
            icon: <DocumentIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter pre-request document',
            label: 'pre-request document',
            name: 'preRequestDocument',
            required: false,
            componentInputElement: gusPreRequestDocumentRef,
        },
        {
            type: 'select',
            icon: <PrimaryCourseIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'primary cause',
            name: 'GUSPrimaryCause',
            required: false,
            componentSelectElement: gusPrimaryCauseRef,
            placeholder: 'Not selected',
            optionList: gusPrimaryCause
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'GUS date',
            name: 'GUSDate',
            required: true,
            componentInputElement: gusDateRef,
        },
        /* {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter requester\'s department',
            label: 'requester\'s department',
            name: 'requestersDepartment',
            required: false,
            componentInputElement: hwnRequestersDepartmentRef,
        } */
        {
            type: 'select',
            icon: <DepartmentIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'requester\'s department',
            name: 'requestersDepartment',
            required: false,
            placeholder: 'Not selected',
            componentSelectElement: gusRequestersDepartmentRef,
            optionList: departments,
            disabled: true
        }
    ]

    useEffect(() => {
        // let department = ''
        // let contact = ""
        // const userJson = sessionStorage.getItem("userdetails");
        // if (userJson) 
        // {
        //     const user = JSON.parse(userJson);
        //     department = user.department
        //     contact = user.mobilenumber
        // }
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/identity_manager/api/v1/getalldepartments", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            })
            .then((res) => res.json())
            .then((data) => {
                //console.log("Fetched organizations in Create Org:", data);
                const departmentData: SelectItemTypes[] = []
                data.map((item: Department) => {
                    departmentData.push({value: item.departmentid, name: item.departmentname})
                })
                setDepartments(departmentData)
            })
            .catch((err) => console.error("Error fetching organizations:", err));

        if (gusRequestNameRef.current && gusDateRef.current && gusRequestersDepartmentRef.current && gusContactNumberRef.current) 
        {
            gusRequestNameRef.current.value = props.ewType.warningId
            gusRequestersDepartmentRef.current.value = department
            gusContactNumberRef.current.value = contact
            
            const now = new Date();

            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')

            // Format: "2025-07-21T14:30"
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
            gusDateRef.current.value = currentDateTime
        }

        fetch(`${BASE_URL}/ew/api/v1/getCurrentProcess?type=GUS`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then(response => response.json())
        .then(data => {
            const values = data as ResponseTypes
            const newData = values.data as ResponseGetActiveWarningDto[]
            setOldAlert(newData)
        })
    }, [])

    const [oldAlert, setOldAlert] = useState<ResponseGetActiveWarningDto[]>([])
    useEffect(() => {
        setGUSTableData(prevState => {
            const updatedState = [...prevState]
            
            oldAlert.forEach(alertItem => {
                const index = updatedState.findIndex(item => item.type === "GUS" && item.data.code === alertItem.areaCode)

                if (index !== -1) {
                    // Item exists → update only previousAlertLevel
                    const currentItem = updatedState[index];
                    if (currentItem.type === "GUS") {
                        updatedState[index] = {
                            ...currentItem,
                            data: {
                                ...currentItem.data,
                                prevSeverity: alertItem.status || ""
                            }
                        };
                    }
                } else {
                    // Item does not exist → add new LSW item
                    const newGUS: GUSAdminData = {
                        code: alertItem.areaCode,
                        name: "",
                        adminName: "",
                        adminLevel: getAdminLevelByCode(alertItem.areaCode),
                        isSelected: true,
                        minWindSpeed: 0,
                        maxWindSpeed: 0,
                        prevSeverity: alertItem.status || "",
                        severity: "",
                        lightingRiskLevel: "",
                        startDate: startDate || "",
                        endDate: endDate || ""
                    }
                    updatedState.push({ type: "GUS", data: newGUS } as AdminData);
                }
            })
            return updatedState;
        })
    }, [oldAlert])

    useEffect(() => {
        // let department = ''
        // const userJson = sessionStorage.getItem("userdetails");
        // if (userJson) 
        // {
        //     const user = JSON.parse(userJson);
        //     department = user.department
        // }

        if (gusRequestersDepartmentRef.current) 
        {
            gusRequestersDepartmentRef.current.value = department
        }

    }, [departments])

    // Table data row
    //const [tableData, setTableData] = useState<AdministrativeLevels>(sriLankaAdministrationLevel)
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([])
    const [tableData, setTableData] = useState<FlatAdmin[]>([])
    const [pagination, setPagination] = useState<FlatAdmin[][]>([])
    const [selectedPagination, setSelectedPagination] = useState<number>(0)

    const [GUSTableData, setGUSTableData] = useState<AdminData[]>([])
    const GUSTableDataRef = useRef<AdminData[]>([])
    const GUSObjectRef = useRef<GUSDataRefType>({
        gusNumber: '',
        requestName: '',
        contactNumber: '',
        preRequestNumber: '',
        validityStartTime: '',
        validityEndTime: '',
        primaryCause: '',
        lightingRiskLevel: '',
        gusDate: '',
        requestsDepartment: '',
        adminData: [],
        desEnglish: '',
        desDhivehi: '',
        desSinhala: '',
        desBengali: '',
        reportedLink: '',
        supportDocument: null,
        warningId: '',

        desCusEnglish: '',
        desCusDhivehi: '',
        desCusSinhala: '',
        desCusBengali: '',
        desCusTamil: '',
    })

    const [selectedArea, setSelectedArea] = useState<string[]>([])
    const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        
        if (event.target.checked) {
            setSelectedArea(prevState => [...prevState, event.target.name])
        } else {
            setSelectedArea(prevState => prevState.filter(item => item !== event.target.name))
        }
    }

    // Pagination next prev navigation
    const paginationNavigation = (side: "next" | "prev") => {
        if (side === "next") {
            if (pagination.length > selectedPagination + 1) {
                setSelectedPagination(prevState => prevState + 1)
                //console.log(">>>> good next")
            }
           
        } else if (side === "prev") {
            if (0 <= selectedPagination - 1){
                setSelectedPagination(prevState => prevState - 1)
            }
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
            GUSObjectRef.current.supportDocument = event.target.files[0]
        } else {
            setFileName('Upload');
        }
    }

    // Handle save data
    const handleSaveClick = async () => {
        setIsLoading(true)

        const gusNumberRefField = validateField(gusNumberRef)
        const gusDateRefField = validateField(gusDateRef)
        const gusValidityStartRefField = validateField(gusValidityStartRef)
        const gusValidityEndRefField = validateField(gusValidityEndRef)
        
        if (!gusNumberRefField || !gusDateRefField || !gusValidityStartRefField || !gusValidityEndRefField) {
            setIsLoading(false)
            return showAlertDialog("Validation Error", "❌ Validation error");
        }
   
        /* if (areaSelectType === 'table') {
            HWNTableDataRef.current = Object.entries(rowStates).map(([code, state]) => ({
            type: 'HWN',
            data: {
                name: tableData.find(item => item.code === code)?.name || "",
                code,
                adminName: tableData.find(item => item.code === code)?.adminLevel || "",
                adminLevel: tableData.find(item => item.code === code)?.adminLevel || "",
                severity: state.severity,
                minWindSpeed: state.minWind,
                maxWindSpeed: state.maxWind,
                lightning: state.lightingRiskLevel,
                startDate: state.startDate || startDate,
                endDate: state.endDate || endDate
            }
            }))
        } */
        for (const item of GUSTableData) {
            const data = item.data as GUSAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.severity && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

        if (GUSObjectRef.current) 
        {
            if(gusNumberRef.current && gusRequestNameRef.current && gusContactNumberRef.current && gusPreRequestDocumentRef.current && gusValidityStartRef.current && gusValidityEndRef.current && gusPrimaryCauseRef.current && gusDateRef.current && gusRequestersDepartmentRef.current && GUSTableDataRef.current && gusTextAreaEnglishRef.current && gusTextAreaDhivehiRef.current && gusReportedLinkRef.current && fileInputRef.current && csvSubNameRef.current && subscriberSaveRef.current) 
            {
                GUSObjectRef.current.gusNumber = gusNumberRef.current.value
                GUSObjectRef.current.requestName = gusRequestNameRef.current.value
                GUSObjectRef.current.contactNumber = gusContactNumberRef.current.value
                GUSObjectRef.current.preRequestNumber = gusPreRequestDocumentRef.current.value
                GUSObjectRef.current.validityStartTime = gusValidityStartRef.current.value
                GUSObjectRef.current.validityEndTime = gusValidityEndRef.current.value
                GUSObjectRef.current.primaryCause = gusPrimaryCauseRef.current.value
                GUSObjectRef.current.gusDate = gusDateRef.current.value
                GUSObjectRef.current.requestsDepartment = gusRequestersDepartmentRef.current.value
                GUSTableData.map(item => {
                    const data = item.data as GUSAdminData
                    const existOnOldAlert = oldAlert.some(alert => alert.areaCode === data.code)

                    if (existOnOldAlert && data.severity === "") return
                    GUSObjectRef.current.adminData.push(item.data as GUSAdminData)
                })
                //console.log(">>>>>>>>>>>>> AREAS: ", GUSObjectRef.current.adminData)
                //HWNObjectRef.current.adminData = HWNTableDataRef.current
                GUSObjectRef.current.desEnglish = gusTextAreaEnglishRef.current.value
                GUSObjectRef.current.desDhivehi = gusTextAreaDhivehiRef.current.value

                if (COUNTRY === "SRI_LANKA" && gusTextAreaSinhalaRef.current)
                {
                    GUSObjectRef.current.desSinhala = gusTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && gusTextAreaBengaliRef.current)
                {
                    GUSObjectRef.current.desBengali = gusTextAreaBengaliRef.current.value
                }
                
                GUSObjectRef.current.reportedLink = gusReportedLinkRef.current.value
                GUSObjectRef.current.warningId = props.ewType.warningId
               
                const gusData: GUSDataRefType = GUSObjectRef.current
                                    
                const gusAdminData: APIRequestAddAreaTypes[] = []
        
                gusData.adminData.map(area => {
                    const newAdmin: APIRequestAddAreaTypes = {
                        code: area.code,
                        administrationName: area.adminName,
                        administrationLevel: area.adminLevel,
                        minWind: area.minWindSpeed,
                        maxWind: area.maxWindSpeed,
                        previousAlertLevel: area.prevSeverity,
                        severity: area.severity,
                        lightingRiskLevel: area.lightingRiskLevel,
                        startDate: convertToOffsetDateTime(area.startDate),
                        endDate: convertToOffsetDateTime(area.endDate)
                    }
                    gusAdminData.push(newAdmin)
                })
        
                const GUSNewRequestBody: APIRequestWarningAddTypes = {
                    triggerType: "ADV",
                    warningNumber: gusData.gusNumber,
                    type: 'GUS',
                    requestName: gusData.requestName,
                    contactNumber: gusData.contactNumber,
                    preRequestDocument: gusData.preRequestNumber,
                    validityStartTime: convertToOffsetDateTime(gusData.validityStartTime),
                    validityEndTime: convertToOffsetDateTime(gusData.validityEndTime),
                    primaryCause: gusData.primaryCause,
                    warningDate: convertToOffsetDateTime(gusData.gusDate),
                    requestersDepartment: gusData.requestsDepartment,
                    effectedAreas: gusAdminData,
                    messageBodyEnglish: gusData.desEnglish,
                    messageBodyDhivehi: gusData.desDhivehi,
                    messageBodySinhala: gusData.desSinhala,
                    messageBodyBengali: gusData.desBengali,
                    reportLink: gusData.reportedLink,
                    supportiveDocument: gusData.supportDocument,
                    warningId: gusData.warningId,
                    csvData: csvData,
                    isCsvSave: subscriberSaveRef.current.checked,
                    csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,

                    messageCusBodyEnglish: gusData.desCusEnglish,
                    messageCusBodyDhivehi: gusData.desCusDhivehi,
                    messageCusBodySinhala: gusData.desCusSinhala,
                    messageCusBodyBengali: gusData.desCusBengali,
                    messageCusBodyTamil: gusData.desCusTamil,
                }
        
                // Send request
                try
                {
                    const response = await APICallNewWarningRequest(GUSNewRequestBody)
                    
                    if (!response.errorCode)
                    {
                        console.log("✅ Gust submitted successfully");
                        showAlertDialog("Success", "✅ Gust submitted successfully!", undefined, () => window.location.reload());
                    } 
                    else 
                    {
                        switch (response.errorCode) {
                            case 1010:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                break
                            default:
                                console.log("❌ ", response.errorMessage);
                                showAlertDialog("Error", "❌ Error adding data");
                        }
                        
                    }
                } 
                catch (ex)
                {
                    console.error("❌ Gust submit exception:", ex);
                    showAlertDialog("Submit Error", "❌ Gust submit exception");

                }
            }
        }
        setIsLoading(false)
    }

    // Selected country
    const country = process.env.REACT_APP_COUNTRY

    const [allowedAreas, setAllowedAreas] = useState<string[]>([])
    useEffect(() => {
        // const getUserAreas = async () => {
        //     const response = await APIGetUserAreas()
        //     //console.log('AREAS ->', response.data)
        //     if (!response)
        //     {
        //         showAlertDialog('Error', '❌ data loading failed')
        //     }
        //     setAllowedAreas(response.data)
        //     if (country === "SRI_LANKA") {
        //         const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
        //         setTableData(flat)
        //         setFilterTableData(flat)
        //     } else if (country === "MALDIVES") {
        //         const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
        //         const filtered: FlatAdmin[] = flat.filter(item => response.data.some(code => item.code.startsWith(code)))
        //         setTableData(filtered)
        //         setFilterTableData(filtered)
        //     }
        // }
        // getUserAreas()

        setAllowedAreas(areas)
        
        if (country === "SRI_LANKA") {
            const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
            setTableData(flat)
            setFilterTableData(flat)
        } else if (country === "MALDIVES") {
            const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
            const filtered: FlatAdmin[] = flat.filter(item => areas.some(code => item.code.startsWith(code)))
            setTableData(filtered)
            setFilterTableData(filtered)
        }
    }, [])

    useEffect(() => {
        setPagination(paginationList(filterTableData, numberOfRows))
    }, [tableData, filterTableData, numberOfRows])

    // Handle table search
    const handelSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilterTableData(tableData)
        } else {
            setFilterTableData(tableData.filter(item => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
        }
    }

    const handleGUSMinWind = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;

        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            minWindSpeed: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleGUSMaxWind = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = parseFloat(event.target.value) || 0;

        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            maxWindSpeed: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleGUSPrevSeverity = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        
        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            prevSeverity: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleGUSSeverity = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        
        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            severity: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleGUSLightning = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        
        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            lightning: value,
                            lightingRiskLevel: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleGUSStartDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        
        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            startData: value
                        }
                    };
                }
                return row;
            })
        )
    }
    
    const handleGUSEndDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name;
        const value = event.target.value;
        
        setGUSTableData(prevData =>
            prevData.map(row => {
                if (row.type === "GUS" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            endDate: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const getAllChildIslandCodes = (level: AdministrativeLevel): string[] => {
        if (!level.children) return [];

        const codes: string[] = [];
        Object.entries(level.children).forEach(([code, child]) => {
            if (child.adminLevel === 'island') {
                codes.push(code);
            }

            // Recurse deeper
            codes.push(...getAllChildIslandCodes(child));
        });

        return codes;
    }

    const findAdminByCode = (levels: AdministrativeLevels, code: string): AdministrativeLevel | null => {
        for (const [key, level] of Object.entries(levels)) {
            if (key === code) return level;
            if (level.children) {
            const result = findAdminByCode(level.children, code);
            if (result) return result;
            }
        }
        return null;
    }

    useEffect(() => {
        const visibleData = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        const paginated = paginationList(visibleData, numberOfRows);
        setPagination(paginated);

        // Reset to first page if current page is out of bounds after filtering
        if (selectedPagination >= paginated.length) {
            setSelectedPagination(0);
        }
    }, [filterTableData, numberOfRows, hiddenIslandCodes])
    
    const handleCheckBoxClick = (event: ChangeEvent<HTMLInputElement>) => {
        handleCheckBox(event);

        const code = event.target.name;
        const isChecked = event.target.checked;

        /* setRowStates(prev => {
            const newState = { ...prev };
            if (isChecked && !newState[code]) {
            newState[code] = {
                isSelected: true,
                severity: "",
                minWind: 0,
                maxWind: 0,
                lightingRiskLevel: "",
                startDate: startDate || "",
                endDate: endDate || ""
            };
            } else if (!isChecked) {
            delete newState[code];
            }
            return newState;
        }); */

        // Determine which admin structure to use
        const adminSource = country === 'SRI_LANKA' ? sriLankaAdministrationLevel : maldivesAdministrativeLevel;

        // Find the clicked admin level (atoll or island)
        const clickedAdminLevel = findAdminByCode(adminSource, code);

        // If it's an atoll, toggle island visibility
        if (clickedAdminLevel && clickedAdminLevel.adminLevel === 'atoll') {
        const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel);
        setHiddenIslandCodes(prev =>
            isChecked
            ? [...prev, ...childIslandCodes] // hide children
            : prev.filter(code => !childIslandCodes.includes(code)) // show again
        );
        }

        if (event.target.checked) {
            const alreadyExists = GUSTableData.some(item => item.type === 'GUS' && item.data.code === event.target.name)
            
            if (!alreadyExists) 
            {
                console.log("Already exists")
                const data = tableData.find(obj => obj.code === event.target.name);
                if (data) {
                    /*  LSWTableDataRef.current.push({
                        type: 'LSW',
                        data: {
                            isSelected: true,
                            name: data.name,
                            code: data.code,
                            adminName: data.adminLevel,
                            adminLevel: data.adminLevel,
                            newAlertLevel: "",
                            previousAlertLevel: "",
                            lightingRiskLevel: "",
                            rainfall: 0,
                            startDate: lswValidityStartRef.current?.value || '',
                            endDate: lswValidityEndRef.current?.value || ''
                        }
                    }) */

                    setGUSTableData(prevState => {
                        return [...prevState, {
                            type: 'GUS',
                            data: {
                                isSelected: true,
                                name: data.name,
                                code: data.code,
                                adminName: data.adminLevel,
                                adminLevel: data.adminLevel,
                                minWindSpeed: 0,
                                maxWindSpeed: 0,
                                lightingRiskLevel: "",
                                prevSeverity: "",
                                severity: "",
                                startDate: gusValidityStartRef.current?.value || startDate,
                                endDate: gusValidityEndRef.current?.value || endDate
                            }
                        }]
                    })
                }
            }
        } else {
            setGUSTableData(prevState => prevState.filter(item => !(item.type === 'GUS' && item.data.code === event.target.name)))
        }
    }

    // Handle Row number change
    const handleRowNumberChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setNumberOfRows(event.target.valueAsNumber)
    }

    const handleTableClick = () => {
        //setSelectedCodes(new Set())
        //HWNTableDataRef.current = []
        //setRowStates({})
        setSelectedArea([])
        setAreaSelectType('table')
    }

    const handleMapClick = () => {
        //setSelectedCodes(new Set())
        //HWNTableDataRef.current = []
        //setRowStates({})
        setSelectedArea([])
        setAreaSelectType('map')
    }

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await APICallGenerateProcKeyRequest(props.ewType.warningId); // Pass prop here
                if (response && !response.errorCode) {
                    //console.log("✅ API data loaded: ", response);
                    // Example: store a process key in state
                    // setProcKey(response.processKey);

                    if (gusNumberRef.current) {
                        gusNumberRef.current.value = response.data;
                    }

                } else {
                    console.warn("⚠️ API returned an error:", response?.errorMessage);
                    showAlertDialog("Error", "Failed to load initial data");
                }
            } catch (error) {
                console.error("❌ Error fetching data:", error);
                showAlertDialog("Network Error", "Failed to fetch initial data.");
            }
        };

        fetchInitialData();
    }, [props.ewType]); 

    // Handle HRW generate
    const handleGenerateEWMessageData = async (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)
  
        const gusNumberRefField = validateField(gusNumberRef)
        const gusDateRefField = validateField(gusDateRef)
        const gusValidityStartRefField = validateField(gusValidityStartRef)
        const gusValidityEndRefField = validateField(gusValidityEndRef)
        
        if (!gusNumberRefField || !gusDateRefField || !gusValidityStartRefField || !gusValidityEndRefField) {
            setIsLoading(false)
            return showAlertDialog("Validation Error", "❌ Validation error");
        }

        /* if (areaSelectType === 'table') {
            HWNTableDataRef.current = Object.entries(rowStates).map(([code, state]) => ({
            type: 'HWN',
            data: {
                name: tableData.find(item => item.code === code)?.name || "",
                code,
                adminName: tableData.find(item => item.code === code)?.adminLevel || "",
                adminLevel: tableData.find(item => item.code === code)?.adminLevel || "",
                severity: state.severity,
                minWindSpeed: state.minWind,
                maxWindSpeed: state.maxWind,
                lightning: state.lightingRiskLevel,
                startDate: state.startDate || startDate,
                endDate: state.endDate || endDate
            }
            }))
        } */

        for (const item of GUSTableData) {
            const data = item.data as GUSAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.severity && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

        if (GUSObjectRef.current) 
        {
            if(gusNumberRef.current && gusRequestNameRef.current && gusContactNumberRef.current && gusPreRequestDocumentRef.current && gusValidityStartRef.current && gusValidityEndRef.current && gusPrimaryCauseRef.current && gusDateRef.current && gusRequestersDepartmentRef.current && GUSTableDataRef.current && gusTextAreaEnglishRef.current && gusTextAreaDhivehiRef.current && gusReportedLinkRef.current && fileInputRef.current && csvSubNameRef.current && subscriberSaveRef.current && gusTextAreaCusDhivehiRef.current && gusTextAreaCusEnglishRef.current) 
            {
                GUSObjectRef.current.gusNumber = gusNumberRef.current.value
                GUSObjectRef.current.requestName = gusRequestNameRef.current.value
                GUSObjectRef.current.contactNumber = gusContactNumberRef.current.value
                GUSObjectRef.current.preRequestNumber = gusPreRequestDocumentRef.current.value
                GUSObjectRef.current.validityStartTime = gusValidityStartRef.current.value
                GUSObjectRef.current.validityEndTime = gusValidityEndRef.current.value
                GUSObjectRef.current.primaryCause = gusPrimaryCauseRef.current.value
                GUSObjectRef.current.gusDate = gusDateRef.current.value
                GUSObjectRef.current.requestsDepartment = gusRequestersDepartmentRef.current.value
                GUSTableData.map(item => {
                    const data = item.data as GUSAdminData
                    const existOnOldAlert = oldAlert.some(alert => alert.areaCode === data.code)

                    if (existOnOldAlert && !data.severity) return
                    GUSObjectRef.current.adminData.push(item.data as GUSAdminData)
                })
                //console.log(">>>>>>>>>>>>> AREAS: ", GUSObjectRef.current.adminData)
                //HWNObjectRef.current.adminData = HWNTableDataRef.current
                GUSObjectRef.current.desEnglish = gusTextAreaEnglishRef.current.value
                GUSObjectRef.current.desCusEnglish = gusTextAreaCusEnglishRef.current.value

                GUSObjectRef.current.desDhivehi = gusTextAreaDhivehiRef.current.value
                GUSObjectRef.current.desCusDhivehi = gusTextAreaCusDhivehiRef.current.value

                if (COUNTRY === "SRI_LANKA" && gusTextAreaSinhalaRef.current)
                {
                    GUSObjectRef.current.desSinhala = gusTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && gusTextAreaBengaliRef.current && gusTextAreaCusBengaliRef.current)
                {
                    GUSObjectRef.current.desBengali = gusTextAreaBengaliRef.current.value
                    GUSObjectRef.current.desCusBengali = gusTextAreaCusBengaliRef.current.value
                }

                GUSObjectRef.current.reportedLink = gusReportedLinkRef.current.value
                GUSObjectRef.current.warningId = props.ewType.warningId

                const gusData: GUSDataRefType = GUSObjectRef.current
                                    
                const gusAdminData: APIRequestAddAreaTypes[] = []
        
                gusData.adminData.map(area => {
                    const newAdmin: APIRequestAddAreaTypes = {
                        code: area.code,
                        administrationName: area.adminName,
                        administrationLevel: area.adminLevel,
                        minWind: area.minWindSpeed,
                        maxWind: area.maxWindSpeed,
                        previousAlertLevel: area.prevSeverity,
                        severity: area.severity,
                        lightingRiskLevel: area.lightingRiskLevel,
                        startDate: convertToOffsetDateTime(area.startDate),
                        endDate: convertToOffsetDateTime(area.endDate)
                    }
                    gusAdminData.push(newAdmin)
                })
        
                const GUSNewRequestBody: APIRequestWarningAddTypes = {
                    triggerType: "ADV",
                    warningNumber: gusData.gusNumber,
                    type: 'GUS',
                    requestName: gusData.requestName,
                    contactNumber: gusData.contactNumber,
                    preRequestDocument: gusData.preRequestNumber,
                    validityStartTime: convertToOffsetDateTime(gusData.validityStartTime),
                    validityEndTime: convertToOffsetDateTime(gusData.validityEndTime),
                    primaryCause: gusData.primaryCause,
                    warningDate: convertToOffsetDateTime(gusData.gusDate),
                    requestersDepartment: gusData.requestsDepartment,
                    effectedAreas: gusAdminData,
                    messageBodyEnglish: gusData.desEnglish,
                    messageBodyDhivehi: gusData.desDhivehi,
                    messageBodySinhala: gusData.desSinhala,
                    messageBodyBengali: gusData.desBengali,
                    reportLink: gusData.reportedLink,
                    supportiveDocument: gusData.supportDocument,
                    warningId: gusData.warningId,
                    csvData: csvData,
                    isCsvSave: subscriberSaveRef.current.checked,
                    csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,
                }
                    try {
                        //console.log("TEST -> ", GUSNewRequestBody)
                        const response = await APICallGenerateEWMsgRequest(GUSNewRequestBody)

                        if (!response.errorCode) {
                            //console.log(response);


                            if (gusTextAreaEnglishRef.current && gusTextAreaDhivehiRef.current) {

                                // After got response set to field
                                gusTextAreaEnglishRef.current.value = response.data.ew_generalMsgLanBase // English data in response
                                gusTextAreaDhivehiRef.current.value =response.data.ew_generalMsgLanDV // Dhivehi data in response

                                if (COUNTRY === "SRI_LANKA" && gusTextAreaSinhalaRef.current)
                                {
                                    gusTextAreaSinhalaRef.current.value = response.data.ew_generalMsgLanSI // Sinhala data in response
                                }
                    
                                if (COUNTRY === "MALDIVES" && gusTextAreaBengaliRef.current)
                                {
                                    gusTextAreaBengaliRef.current.value = response.data.ew_generalMsgLanBN // Bengali data in response
                                }
                            }
                            
                        }
                        else {
                            switch (response.errorCode) {
                                case 1010:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                    break
                                default:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Error", "❌ Error adding data");
                            }

                        }
                    }
                    catch (ex) {
                        console.error("❌ Gust submit exception:", ex);
                        showAlertDialog("Submit Error", "❌ Gust submit exception");
                    }
                }
            }
            setIsLoading(false)
        }

    const handleCSVFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCSVErrors(null)
        if (event.target.files && event.target.files.length > 0) {
            setFileCSVName(event.target.files[0].name)
            const file = event.target.files[0]
            
            // Validate File Extension
            if (!file.name.endsWith('.csv'))
            {
                setCSVErrors("Invalid file type. Please upload a CSV file.")
                event.target.value = ''
                return
            }
            else
            {
                setFileCSVName(file.name)
                
                const reader = new FileReader()

                reader.onload = (e) => {

                    const text = e.target?.result as string

                    if (!validateCSVFormat(text).valid)
                    {
                        setCSVErrors("Invalid CSV format. Please upload a CSV file with the correct format.")
                        event.target.value = ''
                        return
                    }

                    const parsedData = parseCSVManually(text)
                    setCSVData(parsedData)
                }

                reader.onerror = () => {
                    setCSVErrors("Error reading CSV file. Please try again.")
                }
                
                reader.readAsText(file)
            }
        } else {
            setFileCSVName('Upload');
        }
    }

    const clearCSV = () => {
        if (!fileInputCSVRef.current) return

        fileInputCSVRef.current.value = ''
        setFileCSVName('Upload')
        setCSVData([])
        setCSVErrors(null)
    }

    const handleClickSaveAndSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (csvErrors !== null)
        {
            showAlertDialog("CSV Error", "Loaded CSV file detected error. Please fix CSV error before submit. if submit without fix CSV error, CSV data will not be uploaded. Do you need to proceed?", () => handleSaveClick(), undefined)
        }
        else
        {
            showAlertDialog("Confirm Submit", "Are you sure you want to submit this early warning?", () => handleSaveClick(), undefined)
        }
    }

    const handleClearCSV = () => {
        setCSVErrors(null)
        setFileCSVName('Upload')
        setCSVData([])
    }

    const existingCSVDataRef = useRef<string[]>([])
    const existingCSVDataSetRef = useRef<SubscriberDataType[]>([])
    const [existingCSVFilterData, setExistingCSVFilterData] = useState<string[]>([])

    // existing data change handle
    const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>): void => {
        if (event.target.value === "") 
        {
            setExistingCSVFilterData(existingCSVDataRef.current);
        } 
        else 
        {
            setExistingCSVFilterData(
                existingCSVDataRef.current.filter((item) =>
                    item.toLowerCase().includes(event.target.value.toLowerCase())
                )
            );
        }
    }

    useEffect(() => {
        const fetchExistingCSVData = async () => {
            setIsCSVDataPickerLoading(true)
            const response = await APIGetAllCustomSubscribers(props.ewType.warningId)

            if (!response.status)
            {

            }
            const tempData: SubscriberDataType[] = []
            const tempFileNames: string[] = []

            response.data?.map(item => {
                tempFileNames.push(item.name)
                item.subscribers.map((subscriber: Subscriber) => {
                    const sub: SubscriberDataType = {
                        name: item.name,
                        whatsappContact: subscriber.whatsappContact,
                        whatsapp: subscriber.whatsapp,
                        smsContact: subscriber.smsContact,
                        sms: subscriber.sms,
                        viberContact: subscriber.viberContact,
                        viber: subscriber.viber,
                        email: subscriber.email
                    }
                    tempData.push(sub)
                })
            })
            existingCSVDataSetRef.current = tempData
            existingCSVDataRef.current = tempFileNames
            setExistingCSVFilterData(tempFileNames)
        }

        fetchExistingCSVData()
        setIsCSVDataPickerLoading(false)
    }, [])

    const handleClickFilteredCSV = (sub: string): void => {
        setCSVData(existingCSVDataSetRef.current.filter(item => item.name === sub))
        setCSVErrors(null)
        csvSubNameRef.current!.value = sub
        setFileCSVName(sub)
        setIsCSVDataPikerOpen(false)
    }

    // Selected groups
    const [selectedGroups, setSelectedGroups] = useState<GetSelectedGroup[]>([])
    // Selected user
    const [selectedSubscribers, setSelectedSubscribers] = useState<UserDataRow[]>([])

    const setSubscribersFromApi = (apiSubscribers: APIResponseSelectedSubscribersType[]): UserDataRow[] => {
            return apiSubscribers.map((item) => ({
                isEditable: item.addUser === username ? true : false,
                id: item.id.userId,
                firstName: '',
                lastName: '',
                email: '',
                sms: item.sms,
                whatsapp: item.whatsapp,
                viber: item.viber
            }))
        }

    useEffect(() => {

        if(!gusRequestNameRef.current) return
        // Get selected groups
        const getAllSelectedGroups = () => {
            const token = localStorage.getItem("access_token") || "";
            fetch(`${BASE_URL}/ew/api/v1/getSelectedGroups?warningCatCode=${gusRequestNameRef.current?.value}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> data: ", data)
                setSelectedGroups(response.data as GetSelectedGroup[])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        };
    
        // Get selected groups
        const getAllSelectedSubscribers = () => {
            const token = localStorage.getItem("access_token") || "";
            fetch(`${BASE_URL}/ew/api/v1/getSelectedSubscribers?warningCatCode=${gusRequestNameRef.current?.value}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> subs: ", response.data)

                setSelectedSubscribers(response.data ? setSubscribersFromApi(response.data as APIResponseSelectedSubscribersType[]) : [])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        };

        getAllSelectedGroups()
        getAllSelectedSubscribers()
    }, [])

    const getSubscribersId = (): APIRequestSelectedSubscribersType[] => {
        let result: APIRequestSelectedSubscribersType[] = []
    
        selectedSubscribers.map((item) => {
            const newSubscriber: APIRequestSelectedSubscribersType = {
                userId: item.id,
                sms: item.sms,
                whatsapp: item.whatsapp,
                viber: item.viber
            }
            result.push(newSubscriber)
        })
    
        return result
    }

    const getGroupIdList = (groups: GetSelectedGroup[])  => {
        const data: string[] = []
        groups.map(item => (data.push(item.groupId)))
        return data
    }

    const reloadPage = () => {
        //window.location.reload()
    }

    const handleSaveSubscribersAndGroupButtonClick = () => {
        setIsLoading(true)

        if (!gusNumberRef.current || !gusRequestNameRef.current) return
        const token = localStorage.getItem("access_token");
        if (!token) {
            throw new Error("Missing access token");
        }

        const body: APISaveGroupSubTypes = {
            selectedGroups: getGroupIdList(selectedGroups),
            selectedSubscribers: getSubscribersId(),
            warningId: gusNumberRef.current.value,
            workflowId: gusRequestNameRef.current.value

        }

        fetch(`${BASE_URL}/ew/api/v1/saveGroupAndSubscribers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then((res) => res.json())
        .then((data) => {
            const response = data as ResponseTypes

            if (response.httpStatus === 'OK'){
                setIsLoading(false)
                showAlertDialog("Success", "✅ Groups and subscribers saved successfully", undefined, () => reloadPage());
            }
        })
        .catch((err) => {
            setIsLoading(false)
            console.error("Error fetching roles:", err)
            showAlertDialog("Error", "❌ Groups and subscribers saving failed", undefined, () => reloadPage())
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details ({props.ewType.warningName})</span>
                </div>
                <div className='details-selector-wrapper-container' style={{backgroundColor: 'transparent'}}>
                    <div className={`left-side`}>
                        {dataMap.slice(0, sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>

                    <div className={`right-side`}>
                        {dataMap.slice(sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Area Selection)</span>
                </div>
                <div className='tab-button-wrapper'>
                    <span style={{backgroundColor: areaSelectType === 'table' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleTableClick()}>table view mode</span>
                    <span style={{backgroundColor: areaSelectType === 'map' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => handleMapClick()}>map view mode</span>
                </div>
                {areaSelectType === 'table' && (
                    <div className='details-selector-wrapper-table-container'>
                        <div className='area-table-wrapper'>
                            <div className='field-container'>
                                <div className='input-group' style={{width: '20rem'}}>
                                    <label htmlFor="">display row count</label>
                                    <input ref={numberOfRowsRef} defaultValue={10} min={10} max={30} type="number" onChange={(e) => handleRowNumberChanged(e)} />
                                </div>
                                <div className='input-group'>
                                    <i><SearchIcon width="1rem" color="var(--color-main-white)" /></i>
                                    <input type="text" name="" id="" placeholder='Search location' onChange={handelSearchChange}/>
                                </div>
                            </div>
                            <div className='table-wrapper'>
                                <div className='row header'>
                                    <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                        <span></span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Area</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Administration Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Min Wind Speed(kmph)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Max Wind Speed(kmph)</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Previous Severity</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Severity</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Lighting</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Start Date</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>End Date</span>
                                    </div>
                                </div>

                                {pagination[selectedPagination]?.map((item, index) => {
                                const currentRowState = GUSTableData.find((row): row is { type: 'GUS'; data: GUSAdminData } => row.type === 'GUS' && row.data.code === item.code )?.data ?? {
                                        isSelected: false,
                                        code: item.code,
                                        name: item.name,
                                        adminName: item.name,
                                        adminLevel: item.adminLevel,
                                        maxWindSpeed: 0,
                                        minWindSpeed: 0,
                                        severity: "",
                                        prevSeverity: "",
                                        lightning: '',
                                        lightingRiskLevel: "",
                                        startDate: startDate,
                                        endDate: endDate,
                                    };
                                return (
                                    <div key={index} className='row'>
                                    <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                        <input 
                                        type="checkbox" 
                                        name={item.code} 
                                        checked={currentRowState.isSelected}
                                        onChange={(e) => handleCheckBoxClick(e)} 
                                        />
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <span>{item.name}</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <span>{item.adminLevel}</span>
                                    </div>
                                    
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <input 
                                        value={currentRowState.minWindSpeed || '0'} 
                                        type="number" 
                                        name={item.code}
                                        onChange={(e) => handleGUSMinWind(e)}
                                        min={0}
                                        />
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <input 
                                        value={currentRowState.maxWindSpeed || '0'} 
                                        type="number" 
                                        name={item.code}
                                        onChange={(e) => handleGUSMaxWind(e)}
                                        min={0}
                                        />
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <select name={item.code} value={currentRowState.prevSeverity || ''} onChange={(e) => handleGUSPrevSeverity(e)} disabled={true}>
                                        <option value="">Not Selected</option>
                                        {gusSeverity.map((opt, idx) => (
                                            <option key={idx} value={opt.value}>{opt.name}</option>
                                        ))}
                                        </select>
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <select 
                                        name={item.code} 
                                        value={currentRowState.severity || ''}
                                        onChange={(e) => handleGUSSeverity(e)}
                                        >
                                        <option value="">Not Selected</option>
                                        {gusSeverity.map((opt, idx) => (
                                            <option key={idx} value={opt.value}>{opt.name}</option>
                                        ))}
                                        </select>
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem'}}>
                                        <select 
                                        name={item.code} 
                                        value={currentRowState.lightingRiskLevel || ''}
                                        onChange={(e) => handleGUSLightning(e)}
                                        >
                                        <option value="">No Risk</option>
                                        {gusLightning.map((opt, idx) => (
                                            <option key={idx} value={opt.value}>{opt.name}</option>
                                        ))}
                                        </select>
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                        <input 
                                        type="datetime-local" 
                                        value={currentRowState.startDate || startDate}
                                        name={item.code} 
                                        onChange={(e) => handleGUSStartDate(e)} 
                                        style={{width: '8rem'}}
                                        />
                                    </div>
                                    <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                        <input 
                                        type="datetime-local" 
                                        value={currentRowState.endDate || endDate}
                                        name={item.code} 
                                        onChange={(e) => handleGUSEndDate(e)} 
                                        style={{width: '8rem'}}
                                        />
                                    </div>
                                    </div>
                                );
                            })}
                            </div>
                        </div>
                        <div className='pagination-wrapper'>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                            <div className='page-wrapper'>
                                {pagination.map((page, index) => (
                                    <div key={index} className={selectedPagination === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPagination(index)}>{index + 1}</div>
                                ))}
                            </div>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("next")}>&gt;</div>
                        </div>
                    </div>
                )}

                {areaSelectType === 'map' && (
                    <div className='map-wrapper'>
                        <MapSelector type='GUS' setData={GUSTableDataRef} startDate={startDate} endDate={endDate} tableData={GUSTableData} setTableData={setGUSTableData} allowedAreas={allowedAreas}/>
                    </div>
                )}
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Intended Dissemination of Information to People)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container'>
                        <span>message body SMS - english</span>
                        <textarea ref={gusTextAreaEnglishRef} name="" id=""></textarea>
                    </div>
                    <div className='form-container'>
                        <span>message body SMS - dhivehi</span>
                        <textarea ref={gusTextAreaDhivehiRef} name="" id=""></textarea>
                    </div>

                    {COUNTRY === "SRI_LANKA" ? (
                        <div className='form-container'>
                            <span>message body SMS - sinhala</span>
                            <textarea ref={gusTextAreaSinhalaRef} name="" id=""></textarea>
                        </div>
                    ) : COUNTRY === "MALDIVES" ? (
                        <div className='form-container'>
                            <span>message body SMS - Bengali</span>
                            <textarea ref={gusTextAreaBengaliRef} name="" id=""></textarea>
                        </div>
                    ) : null}
                    
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>report link</span>
                        <input ref={gusReportedLinkRef} type='text' name="" id=""></input>
                    </div>
                    <div className='button-wrapper'>
                        <button onClick={(e) => handleGenerateEWMessageData(e)}>generate EW message data</button>
                    </div>

                    {/* More message options */}
                    <div className='message-more-wrapper'>
                        <div className='title-wrapper'>
                            <span className='title' onClick={() => setMessageAreaStatus(prevState => !prevState)}>More Messaging options..</span>
                            <div>
                                {messagingAreaStatus ? <UpIcon width='0.8rem' color='var(--color-text)' /> : <DownIcon width='1rem' color='var(--color-text)' />}
                            </div>
                        </div>
                        <div className='data-wrapper' style={{ maxHeight: messagingAreaStatus ? '500px' : '0' }}>
                            
                            <div className='messaging-legend-wrapper'>
                                <span>Message Placeholders</span>
                                <div>
                                    <span>Warning Id: {'${warningId}'}</span>
                                    <span>Warning Name: {'${warningName}'}</span>
                                    <span>Area Name: {'${areaName}'}</span>
                                    <span>Severity: {'${severity}'}</span>
                                    <span>Validity Start Time: {'${validityStart}'}</span>
                                    <span>Validity End Time: {'${validityEnd}'}</span>
                                </div>
                            </div>

                            <div className='form-container'>
                                <span>local message body - english</span>
                                <textarea ref={gusTextAreaCusEnglishRef} name="" id=""></textarea>
                            </div>
                            
                            {COUNTRY === "SRI_LANKA" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - sinhala</span>
                                        <textarea ref={gusTextAreaCusSinhalaRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - tamil</span>
                                        <textarea ref={gusTextAreaCusTamilRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : COUNTRY === "MALDIVES" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - dhivehi</span>
                                        <textarea ref={gusTextAreaCusDhivehiRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - Bengali</span>
                                        <textarea ref={gusTextAreaCusBengaliRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Additional Information to Support Approval)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>supportive documents</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileName}</span>
                            <label className="browse-button">
                                Browse
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} className="file-input" />
                            </label>
                            </div>
                    </div>
                </div>
            </div>

            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                <div className='subscribe-data-table-wrapper'>
                    <>
                        <div className='table-set-wrapper-ew' style={{marginTop: "1rem", display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                            <GroupSelectTable selectedGroup={selectedGroups} setSelectedGroup={setSelectedGroups} type="INTERNAL" token={undefined}/>
                            <UserSelectTable  userSelect={selectedSubscribers} setUserSelect={setSelectedSubscribers} type="INTERNAL" token={undefined}/>
                        </div>
                    </>
                </div>
                </div>
                <div className="button-container" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', padding: '1rem' }}>
                    <button style={{ padding: '0.6rem 2rem', border: 'none', borderRadius: '0.5rem', backgroundColor: 'var(--color-accent-bg)', color: 'var(--color-main-white)', cursor: 'pointer' }} onClick={(e) => {
                            showAlertDialog(
                                "Send dissemination messages",
                                "Are you sure you want to save selected subscribers and groups?",
                                handleSaveSubscribersAndGroupButtonClick, undefined
                            ) 
                        }}>Save subscribers and Groups</button>
                </div>
            </div>
            
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Custom Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV)</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileCSVName}</span>
                            <label className={csvData.length > 0 ? 'browse-button clear-btn' : 'browse-button'}>
                                { csvData.length > 0 ? (
                                    <button onClick={(e) => handleClearCSV()}>Clear</button>
                                ) : (
                                    <>
                                        Browse
                                        <input type="file" ref={fileInputCSVRef} onChange={handleCSVFileChange} className="file-input" accept='.csv,text/csv' style={{ textTransform: 'none' }} />
                                    </>
                                )}
                                
                            </label>
                        </div>
                    </div>
                    {csvErrors && (
                        <div className='csv-form-container'>
                            <span>{csvErrors}</span>
                            <span className='clear-button' onClick={(e) => clearCSV()}>Remove CSV</span>
                        </div>
                    )}
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV) Name</span>
                        <div className="custom-upload-container-picker">
                            <div className='pick-icon' onClick={(e) => setIsCSVDataPikerOpen(prevState => !prevState)}>
                                <FormIconDataPicker color='var(--color-text)' width='1rem'/>
                            </div>
                            <input type="text" ref={csvSubNameRef} placeholder={`Default name (${fileCSVName.split('.')[0]})`} />
                        </div>
                    </div>
                    <div className='check-form-container'>
                        <div className='check-box'>
                            <input type="checkbox" ref={subscriberSaveRef} id="save-subs_csv" />
                            <label htmlFor="save-subs_csv">Save subscribers data</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                <div className={`left-side`}></div>
                <div className={`right-side`}>
                    <button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}}>cancel</button>
                    <button className={`button-normal`} onClick={()=>
                        showAlertDialog(
                            "Confirm Submit",
                            "Are you sure you want to submit this early warning?",
                            () => handleSaveClick(), undefined)
                    }>save & submit</button>
                </div>
            </div>
            {isCSVDataPikerOpen && (
                <div className="data-picker-table-wrapper-new">
                    <div className="data-picker-table-container">
                        <div className="search-wrapper">
                            <input type="text" placeholder="Search CSVs" onChange={(e) => handleChangeExistingDataSearch(e)} />
                            <div className="search-icon">
                                <SearchIcon width="1rem" color="var(--color-main-white)" />
                            </div>
                            <div className="close-icon" onClick={(e) => setIsCSVDataPikerOpen(false)} >
                                <CloseIcon width="1.5rem" color="var(--color-text)" />
                            </div>
                        </div>
                        <div className="row header">
                            {/* <span style={{ width: '33%' }}>Country</span> */}
                            <span style={{ width: '100%' }}>CSV Name</span>
                        </div>
                        
                        {isCSVDataPickerLoading ? (
                            <div className="searching-data">
                                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
                                <span>Searching CSVs...</span>
                            </div>
                        ) : (
                            <div className="data-wrapper">
                                {existingCSVFilterData.map((sub, index) => (
                                    <div
                                        key={index}
                                        className="row"
                                        onClick={(e) => handleClickFilteredCSV(sub)}
                                    >
                                        <span style={{ width: '100%', textAlign: 'left' }}>{sub}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!isCSVDataPickerLoading && existingCSVFilterData.length === 0 && (
                            <div className="searching-data">
                                <span>No CSVs found.</span>
                            </div>
                        )}
                        
                    </div>
                </div>
            )}
            {alertDialogState && (
                <AlertDialog
                    title={alertTitle}
                    description={alertDescription}
                    windowState={alertDialogState}
                    setWindowState={setAlertDialogState}
                    function={alertYesCallback}
                    okFunction={alertOkCallback}
                />
            )}
            {isLoading && (
                <LoadingScreen />
            )}
        </div>
    )
}

export default GUSWarning